var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSparkleIcon = function SvgSparkleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "currentColor",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75,
    d: "M12.205 16.783 11 21l-1.205-4.217a6.67 6.67 0 0 0-4.578-4.578L1 11l4.217-1.205a6.67 6.67 0 0 0 4.578-4.578L11 1l1.205 4.217a6.67 6.67 0 0 0 4.578 4.578L21 11l-4.217 1.205a6.67 6.67 0 0 0-4.578 4.578",
    className: "sparkle-icon_svg__Vector"
  })));
};
export default SvgSparkleIcon;